import script from "./QrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./QrCode.vue?vue&type=script&setup=true&lang=js"

import "./QrCode.vue?vue&type=style&index=0&id=aa6b5746&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa6b5746"]])

export default __exports__